import {
  addPointsCustomer,
  changeSectorCustomer,
  getCustomerExtendedFormList,
  getCustomerList,
  pathActiveCustomer,
  pathCustomerAdministration,
  pathDeactiveCustomer,
  removePointsCustomer,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { customerActions } from "../reducers/customer";
import { t } from "i18next";
import { toast } from "react-toastify";

export const fetchCustomerList = (id_customer = 0) => {
  return (dispatch) => {
    return apiService
      .get(getCustomerList(id_customer))
      .then((response) => {
        id_customer == 0
          ? dispatch(customerActions.fetchCustomerList(response.data))
          : dispatch(customerActions.fetchCustomerDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCustomFormExtendedList = (country, sector) => {
  return (dispatch) => {
    return apiService
      .get(getCustomerExtendedFormList(country, sector))
      .then((response) => {
        dispatch(customerActions.fetchCustomerExtendedFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchAddPointsCustomer = (formData, type) => {
  return (dispatch) => {
    if (type == "add") {
      return apiService
        .post(addPointsCustomer(), formData)
        .then((response) => {
          toast.success(t("customerListActions.points"), {
            theme: "colored",
          });
          dispatch(fetchCustomerList());
        })
        .catch((err) => {
          handleError(err);
        });
    } else if (type == "remove") {
      return apiService
        .put(removePointsCustomer(), formData)
        .then((response) => {
          toast.success(t("customerListActions.remove"), {
            theme: "colored",
          });
          dispatch(fetchCustomerList());
        })
        .catch((err) => {
          handleError(err);
        });
    }
  };
};

export const fetchChangeSectorCustomer = (formData) => {
  return (dispatch) => {
    return apiService
      .put(changeSectorCustomer(), formData)
      .then((response) => {
        toast.success("Uspešno ste izmenili sektor korisnika", {
          theme: "colored",
        });
        dispatch(fetchCustomerList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewCustomer = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCustomerAdministration(), data)
      .then((response) => {
        // dispatch(customerActions.fetchCustomerList(response.data));
        navigate("/customer-list");
        toast.success("Uspešno ste kreirali novog korisnika", {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const updateCustomer = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathCustomerAdministration(), data)
      .then((response) => {
        // dispatch(customerActions.fetchCustomerList(response.data));
        navigate("/customer-list");
        toast.success(t("customerListActions.updated"), {
          theme: "colored",
        });
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchActiveCustomer = (id) => {
  return (dispatch) => {
    return apiService
      .patch(pathActiveCustomer(id))
      .then((response) => {
        toast.success(t("customerListActions.activate"), {
          theme: "colored",
        });
        dispatch(fetchCustomerList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeactiveCustomer = (id) => {
  return (dispatch) => {
    return apiService
      .patch(pathDeactiveCustomer(id))
      .then((response) => {
        toast.success(t("customerListActions.deactivate"), {
          theme: "colored",
        });
        dispatch(fetchCustomerList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
